export enum ContractSignStatus {
  Decline = 'declined',
  Signed = 'signed',
  Opened = 'opened',
  Sent = 'sent',
  Delivering = 'delivering',
  Failed = 'failed',
}

export enum ContractSignerType {
  Custom = 0,
  Guest = 1,
  Staff = 2,
}

export enum ContractStatus {
  Pending = 'pending',
  Completed = 'completed',
  Declined = 'declined',
  Canceled = 'cancelled',
  Expired = 'expired',
  Voided = 'voided',
}

export const availableContractStatuses: {
  id: ContractStatus
  name: string
  icon: string
  color: string
}[] = [
  {
    id: ContractStatus.Pending,
    name: $localize`Pending`,
    icon: 'far fa-clock',
    color: 'warning',
  },
  {
    id: ContractStatus.Completed,
    name: $localize`Completed`,
    icon: 'far fa-signature',
    color: 'success',
  },
  {
    id: ContractStatus.Declined,
    name: $localize`Declined`,
    icon: 'far fa-ban',
    color: 'danger',
  },
  {
    id: ContractStatus.Canceled,
    name: $localize`Canceled`,
    icon: 'far fa-times-circle',
    color: 'secondary',
  },
  {
    id: ContractStatus.Expired,
    name: $localize`Expired`,
    icon: 'far fa-hourglass-end',
    color: 'indigo',
  },
]

export const availableContractEventTypes = [
  {
    id: ContractSignStatus.Sent,
    name: 'Sent',
    icon: 'cs-icon cs-icon-mail-receive',
    color: 'indigo',
    bgColor: 'bg-indigo',
  },
  {
    id: ContractSignStatus.Opened,
    name: 'Opened',
    icon: 'cs-icon cs-icon-mail-open',
    color: 'warning',
    bgColor: 'bg-warning',
  },
  {
    id: ContractSignStatus.Signed,
    name: 'Signed',
    icon: 'cs-icon cs-icon-pen-sign2',
    color: 'success',
    bgColor: 'bg-success',
  },
  {
    id: ContractSignStatus.Decline,
    name: 'Declined',
    icon: 'far fa-ban',
    color: 'danger',
    bgColor: 'bg-danger',
  },
  {
    id: ContractSignStatus.Delivering,
    name: 'Delivering',
    icon: 'far fa-paper-plane',
    color: 'info',
    bgColor: 'bg-info',
  },
  {
    id: ContractSignStatus.Failed,
    name: 'Error',
    icon: 'cs-icon cs-icon-envelope-alert',
    color: 'danger',
    bgColor: 'bg-danger',
  },
]
